import type { RegistrationExtendedFormValues } from "./crmPayload";

/** Seed jurisdiction row 1 from mailing address when entering the jurisdictions step. */
export function prepopulateFirstJurisdictionFromMailing(
  extended: RegistrationExtendedFormValues,
): RegistrationExtendedFormValues {
  const row0 = extended.jurisdictions[0];
  if (!row0) return extended;

  const alreadyComplete =
    row0.country.trim().length > 0 &&
    row0.state.trim().length > 0 &&
    row0.county.trim().length > 0;
  if (alreadyComplete) return extended;

  const country = extended.mailingCountry.trim();
  const state = extended.mailingState.trim();
  const county = extended.mailingCounty.trim();
  if (!country || !state || !county) return extended;

  const jurisdictions = [...extended.jurisdictions];
  jurisdictions[0] = { country, state, county };
  return { ...extended, jurisdictions };
}

/**
 * After QC lookup: seed mailing Country/State/County from the first CRM jurisdiction when
 * mailing geo is still empty (inverse of prepopulateFirstJurisdictionFromMailing).
 */
export function prepopulateMailingFromFirstJurisdiction(
  extended: RegistrationExtendedFormValues,
): RegistrationExtendedFormValues {
  const row0 = extended.jurisdictions[0];
  if (!row0) return extended;

  const jCountry = row0.country.trim();
  const jState = row0.state.trim();
  const jCounty = row0.county.trim();
  if (!jCountry || !jState || !jCounty) return extended;

  const mailingGeoEmpty =
    !extended.mailingCountry.trim() &&
    !extended.mailingState.trim() &&
    !extended.mailingCounty.trim();
  if (!mailingGeoEmpty) return extended;

  return {
    ...extended,
    mailingCountry: jCountry,
    mailingState: jState,
    mailingCounty: jCounty,
  };
}
